export interface NewsArticle {
  id: string;
  title: string;
  category: string;
  summary: string;
  content: string[];
  inlineImage: string;
  cover: string;
  source: string;
  author: string;
  publishedAt: string;
  tags: string[];
}

export const newsArticles: NewsArticle[] = [
  {
    id: "n1",
    title: "《星辰大海》口碑持续走高，都市励志题材为何总能打动人心",
    category: "剧集",
    summary:
      "芒果tv独家热播剧《星辰大海》上线以来讨论度不断攀升，平凡人的奋斗故事再一次引发观众共鸣。",
    content: [
      "由芒果tv联合出品的都市励志剧《星辰大海》自上线以来热度持续攀升，话题不断登上榜单。该剧讲述了几位小镇青年在大城市中追逐梦想、彼此扶持的成长故事。",
      "不少观众在评论区留言表示，剧中那些关于选择、坚持与妥协的片段，仿佛照见了自己的生活。有评论认为，真正打动人的从来不是多么宏大的叙事，而是普通人身上那不轻易熄灭的一点光。",
      "剧集在制作层面同样下足功夫，从城市街景到人物造型都力求真实细腻，配乐与镜头语言也克制而有力量。目前全剧已完结，感兴趣的观众可在芒果tv剧集频道一次性追完。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20modern%20Chinese%20urban%20drama%20filming%2C%20warm%20sunset%20light%20over%20a%20city%20street%20set%20with%20soft%20bokeh%2C%20cinematic%20editorial%20photography%2C%20warm%20orange%20and%20amber%20tones%2C%20high%20detail%2C%20calm%20atmosphere&width=1200&height=675&seq=mgtv-n1-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20photo%20about%20a%20popular%20Chinese%20urban%20drama%2C%20warm%20sunset%20over%20a%20modern%20city%20skyline%20with%20soft%20glow%2C%20cinematic%20wide%20composition%2C%20warm%20orange%20and%20amber%20tones%2C%20high%20detail&width=800&height=450&seq=mgtv-n1-cover&orientation=landscape",
    source: "芒果tv娱乐",
    author: "编辑部",
    publishedAt: "2025-10-11",
    tags: ["星辰大海", "都市剧", "剧集观察"],
  },
  {
    id: "n2",
    title: "《长安夜行录》大结局引发热议，古装悬疑还能怎么拍",
    category: "剧集",
    summary:
      "被称为“年度古装悬疑黑马”的《长安夜行录》迎来大结局，多层反转的叙事结构让观众直呼过瘾。",
    content: [
      "《长安夜行录》用一个接一个的谜案，把观众带回了灯火通明的长安城。随着大结局播出，关于剧情走向与人物命运的讨论再次冲上话题榜。",
      "该剧最被称道的，是它在悬疑外壳之下对人性与选择的探讨。每一个案件的背后，都牵连着一段难以言说的往事，也让主角的成长显得扎实可信。",
      "在视觉呈现上，剧组大量采用实景与夜景灯光设计，古城的层次感与氛围感被完整保留下来。对于喜欢古装探案的观众来说，这是一部值得二刷的作品。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Atmospheric%20photo%20of%20an%20ancient%20Chinese%20city%20street%20at%20night%20glowing%20with%20red%20lanterns%2C%20misty%20air%20and%20traditional%20roofs%2C%20cinematic%20editorial%20photography%2C%20deep%20teal%20and%20warm%20gold%20tones%2C%20high%20detail&width=1200&height=675&seq=mgtv-n2-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20news%20photo%20of%20a%20lantern%20lit%20ancient%20Chinese%20city%20at%20night%20with%20mist%2C%20cinematic%20wide%20composition%2C%20deep%20teal%20and%20warm%20gold%20tones%2C%20high%20detail&width=800&height=450&seq=mgtv-n2-cover&orientation=landscape",
    source: "芒果tv娱乐",
    author: "剧评小组",
    publishedAt: "2025-10-09",
    tags: ["长安夜行录", "古装悬疑", "大结局"],
  },
  {
    id: "n3",
    title: "《音乐现场》新一季官宣阵容，多位实力唱将加盟",
    category: "综艺",
    summary: "备受期待的音乐综艺新一季正式官宣首批嘉宾阵容，舞台概念与赛制也将迎来全面升级。",
    content: [
      "芒果tv音乐综艺《音乐现场》近日官宣新一季阵容，多位实力唱将确认加盟，节目将于本月底正式上线。",
      "节目组透露，新一季在舞台设计与音乐编排上都做了大幅调整，力求让每一首作品都拥有完整的现场表达。此外，全新的合作赛制也将让嘉宾之间的音乐碰撞更具看点。",
      "作为一档持续多年的音乐综艺品牌，节目始终坚持“让好音乐被听见”的初衷，也因此积累了一批忠实的乐迷观众。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20spotlights%20and%20glowing%20beams%2C%20silhouette%20of%20a%20singer%20under%20warm%20light%2C%20cinematic%20editorial%20photography%2C%20warm%20orange%20and%20deep%20blue%20tones%2C%20high%20detail&width=1200&height=675&seq=mgtv-n3-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=News%20photo%20of%20a%20dazzling%20music%20concert%20stage%20with%20beam%20lights%20and%20a%20singer%20silhouette%2C%20cinematic%20wide%20composition%2C%20warm%20orange%20and%20deep%20blue%20tones%2C%20high%20detail&width=800&height=450&seq=mgtv-n3-cover&orientation=landscape",
    source: "芒果tv综艺",
    author: "综艺前线",
    publishedAt: "2025-10-07",
    tags: ["音乐现场", "综艺", "阵容官宣"],
  },
  {
    id: "n4",
    title: "《云上之城》特效特辑曝光，国产科幻再交一份高分答卷",
    category: "电影",
    summary: "影片发布幕后特效特辑，揭秘“天空之城”从概念设计到落地成型的全过程。",
    content: [
      "科幻电影《云上之城》近日发布特效制作特辑，向观众展示了影片中那座漂浮云端的未来城市，是如何一步步被搭建出来的。",
      "据介绍，为了呈现云海之上的宏大场景，制作团队耗时数月进行概念设计与预演，力求在视觉奇观之外，也让世界观具备可信的逻辑。",
      "影片上映以来收获了大量好评，不少观众表示，国产科幻在想象力与完成度上都越来越让人惊喜。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Concept%20art%20of%20a%20futuristic%20floating%20city%20above%20a%20sea%20of%20clouds%20with%20glowing%20sky%20lanes%2C%20cinematic%20wide%20composition%2C%20cool%20cyan%20and%20warm%20amber%20accents%2C%20high%20detail%2C%20epic%20atmosphere&width=1200&height=675&seq=mgtv-n4-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=News%20photo%20of%20a%20futuristic%20floating%20city%20above%20clouds%20at%20dawn%2C%20cinematic%20wide%20composition%2C%20cool%20cyan%20and%20warm%20amber%20accents%2C%20high%20detail&width=800&height=450&seq=mgtv-n4-cover&orientation=landscape",
    source: "芒果tv电影",
    author: "影视观察",
    publishedAt: "2025-10-05",
    tags: ["云上之城", "科幻电影", "特效"],
  },
  {
    id: "n5",
    title: "口碑纪录片《舌尖的四季》回归，用一餐一饭讲述中国故事",
    category: "纪录片",
    summary: "高分美食人文纪录片新一季温暖回归，镜头跟随节气走过大江南北的田间与灶台。",
    content: [
      "曾收获大量好评的美食人文纪录片《舌尖的四季》正式回归。新一季依旧以二十四节气为线索，讲述中国人与食物、土地之间的故事。",
      "从春耕到秋收，从渔获到腌渍，镜头记录了食物在四季流转中的变化，也记录了普通人认真生活的样子。",
      "有观众评价，这档节目最动人的地方，是它从不刻意煽情，却总能让人在一顿饭里看到乡愁与温度。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Rustic%20harvest%20table%20with%20steaming%20seasonal%20Chinese%20dishes%20and%20fresh%20ingredients%2C%20warm%20natural%20light%2C%20editorial%20food%20photography%2C%20warm%20earthy%20terracotta%20and%20green%20tones%2C%20high%20detail&width=1200&height=675&seq=mgtv-n5-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=News%20photo%20of%20golden%20farmland%20and%20a%20rustic%20kitchen%20with%20steaming%20dishes%20at%20harvest%2C%20warm%20earthy%20terracotta%20and%20green%20tones%2C%20high%20detail&width=800&height=450&seq=mgtv-n5-cover&orientation=landscape",
    source: "芒果tv纪录",
    author: "纪录片频道",
    publishedAt: "2025-10-03",
    tags: ["舌尖的四季", "纪录片", "美食人文"],
  },
  {
    id: "n6",
    title: "国庆档综艺观察：治愈系慢综艺为何越来越受欢迎",
    category: "综艺",
    summary: "假期期间，多档慢节奏生活综艺收获高口碑，观众对“松弛感”内容的偏好愈发明显。",
    content: [
      "这个假期，主打田园与生活质感的慢综艺再次成为许多人“下饭首选”，其中《田园慢生活》表现尤为亮眼。",
      "与快节奏的竞技综艺不同，慢综艺把镜头对准日常的一餐一景，用平缓的叙事为观众提供一段放松的情绪出口。",
      "有分析指出，随着生活节奏加快，能让人安静下来的内容反而成为稀缺品，这也是治愈系综艺持续走红的深层原因。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Peaceful%20countryside%20scene%20with%20a%20sunlit%20farmhouse%20and%20green%20fields%2C%20soft%20morning%20light%2C%20editorial%20photography%2C%20warm%20cream%20and%20soft%20green%20tones%2C%20high%20detail%2C%20calm%20atmosphere&width=1200&height=675&seq=mgtv-n6-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=News%20photo%20of%20a%20lush%20green%20countryside%20village%20at%20golden%20hour%2C%20soft%20green%20and%20warm%20cream%20tones%2C%20high%20detail%2C%20peaceful%20atmosphere&width=800&height=450&seq=mgtv-n6-cover&orientation=landscape",
    source: "芒果tv综艺",
    author: "综艺前线",
    publishedAt: "2025-10-01",
    tags: ["慢综艺", "综艺观察", "田园慢生活"],
  },
  {
    id: "n7",
    title: "国漫新作《星海少年团》开播，少年冒险故事点燃热血",
    category: "动漫",
    summary: "原创国漫《星海少年团》正式开播，精良的作画与紧凑的剧情收获首批好评。",
    content: [
      "原创国产动画《星海少年团》本周正式开播，讲述五位少年驾驶星舰探索未知星海的故事。",
      "作品在作画与分镜上颇具诚意，宇宙场景的想象力与战斗场面的调度都可圈可点。故事内核则回归少年成长与伙伴羁绊，热血之余也不失温度。",
      "不少观众表示，越来越多国漫开始在类型与制作上大胆尝试，让人对国产动画的未来充满期待。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Vibrant%20anime%20scene%20of%20a%20colorful%20nebula%20with%20a%20sleek%20spaceship%20and%20glowing%20planets%2C%20vivid%20cyan%20orange%20and%20purple%20colors%2C%20high%20detail%2C%20high%20energy%20atmosphere&width=1200&height=675&seq=mgtv-n7-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=News%20photo%20of%20a%20vibrant%20colorful%20space%20nebula%20with%20a%20sleek%20spaceship%2C%20vivid%20cyan%20orange%20and%20purple%20colors%2C%20high%20detail&width=800&height=450&seq=mgtv-n7-cover&orientation=landscape",
    source: "芒果tv动漫",
    author: "动漫情报",
    publishedAt: "2025-09-29",
    tags: ["星海少年团", "国漫", "新番"],
  },
  {
    id: "n8",
    title: "悬疑电影《孤岛回声》上映，密闭空间叙事张力十足",
    category: "电影",
    summary: "悬疑惊悚电影《孤岛回声》正式上线，凭借扎实的剧本与氛围营造收获观众好评。",
    content: [
      "悬疑电影《孤岛回声》讲述三名陌生人在大雾笼罩的孤岛上醒来，随着记忆碎片逐渐拼合，一个惊人的真相浮出水面。",
      "影片大量运用密闭空间与环境音，营造出层层递进的紧张感。剧本在有限的场景中不断抛出新线索，让观众直到最后一刻都难以猜到结局。",
      "对于喜欢烧脑推理的观众来说，《孤岛回声》是一次相当过瘾的观影体验。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Atmospheric%20photo%20of%20a%20lonely%20lighthouse%20on%20a%20foggy%20rocky%20island%20at%20night%20with%20a%20beam%20of%20light%2C%20cinematic%20wide%20composition%2C%20cold%20teal%20and%20grey%20tones%2C%20high%20detail&width=1200&height=675&seq=mgtv-n8-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=News%20photo%20of%20a%20misty%20rocky%20coastline%20with%20a%20lighthouse%20under%20moonlight%2C%20cold%20teal%20and%20grey%20tones%2C%20high%20detail&width=800&height=450&seq=mgtv-n8-cover&orientation=landscape",
    source: "芒果tv电影",
    author: "影视观察",
    publishedAt: "2025-09-27",
    tags: ["孤岛回声", "悬疑电影", "烧脑"],
  },
  {
    id: "n9",
    title: "《厨神请下厨》迎来淘汰赛，选手创意菜品惊艳评审",
    category: "综艺",
    summary: "美食竞技综艺赛程进入白热化阶段，选手以一道创意菜品赢得全场掌声。",
    content: [
      "本周《厨神请下厨》迎来关键的淘汰赛，多位选手在有限时间内发挥创意，用普通食材做出了令人惊喜的作品。",
      "评审团表示，真正打动人的不只是技巧，更是厨师对食材的理解与尊重。节目中不少选手也分享了菜品背后的故事，让一道菜有了温度。",
      "随着赛程推进，竞争愈发激烈，谁能笑到最后也成为观众热议的焦点。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Professional%20kitchen%20scene%20with%20a%20chef%20flambeing%20a%20pan%20and%20steaming%20dishes%2C%20warm%20wok%20fire%20light%2C%20editorial%20food%20photography%2C%20rich%20orange%20and%20deep%20amber%20tones%2C%20high%20detail&width=1200&height=675&seq=mgtv-n9-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=News%20photo%20of%20a%20dramatic%20professional%20kitchen%20with%20steaming%20dishes%20and%20warm%20firelight%2C%20rich%20orange%20and%20deep%20amber%20tones%2C%20high%20detail&width=800&height=450&seq=mgtv-n9-cover&orientation=landscape",
    source: "芒果tv综艺",
    author: "综艺前线",
    publishedAt: "2025-09-25",
    tags: ["厨神请下厨", "美食综艺", "淘汰赛"],
  },
  {
    id: "n10",
    title: "芒果tv秋季片单发布：多部重磅剧集与综艺即将上线",
    category: "行业",
    summary: "芒果tv公布秋季内容片单，涵盖剧集、综艺、电影与纪录片多个品类，看点十足。",
    content: [
      "芒果tv近日发布秋季内容片单，剧集、综艺、电影、动漫与纪录片多个频道均有重磅内容上线。",
      "剧集方面，多部现实题材与悬疑作品将陆续与观众见面；综艺方面，音乐、美食与生活类节目持续加码；此外还有多部纪录片与国漫新作值得期待。",
      "平台表示，未来将继续围绕优质内容与用户体验，为观众带来更丰富的观影选择。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20concept%20with%20colorful%20floating%20media%20cards%20in%20a%20dark%20space%2C%20warm%20orange%20and%20cool%20blue%20accents%2C%20soft%20glow%2C%20high%20detail%2C%20clean%20premium%20aesthetic&width=1200&height=675&seq=mgtv-n10-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=News%20photo%20of%20a%20modern%20streaming%20platform%20concept%20with%20floating%20media%20cards%2C%20warm%20orange%20and%20cool%20blue%20accents%2C%20high%20detail&width=800&height=450&seq=mgtv-n10-cover&orientation=landscape",
    source: "芒果tv娱乐",
    author: "编辑部",
    publishedAt: "2025-09-22",
    tags: ["片单", "行业动态", "芒果tv"],
  },
  {
    id: "n11",
    title: "年代谍战剧《破晓而来》收官，群像叙事获观众点赞",
    category: "剧集",
    summary: "《破晓而来》迎来收官，扎实的群像塑造与克制的叙事风格收获大量好评。",
    content: [
      "年代谍战剧《破晓而来》本周正式收官，剧中一群隐于暗处的无名者，用信念劈开了通往光明的路。",
      "该剧没有过度渲染紧张感，而是把更多笔墨放在人物的信念与抉择上，让每一个角色都有血有肉。群像叙事成为观众讨论最多的话题。",
      "有观众表示，比起单纯的悬疑，这部剧更像是一封写给平凡英雄的信，安静而有力量。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Rainy%20old%20city%20street%20at%20dusk%20with%20warm%20lamps%20and%20fog%2C%20cinematic%20period%20photography%2C%20muted%20teal%20and%20sepia%20tones%2C%20high%20detail%2C%20tense%20atmosphere&width=1200&height=675&seq=mgtv-n11-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=News%20photo%20of%20a%20rainy%20vintage%20city%20street%20at%20dusk%20with%20warm%20lamps%2C%20muted%20teal%20and%20sepia%20tones%2C%20high%20detail&width=800&height=450&seq=mgtv-n11-cover&orientation=landscape",
    source: "芒果tv娱乐",
    author: "剧评小组",
    publishedAt: "2025-09-20",
    tags: ["破晓而来", "谍战剧", "群像"],
  },
  {
    id: "n12",
    title: "《笑声不打烊》更新，观众称“笑着笑着就被治愈了”",
    category: "综艺",
    summary: "脱口秀综艺《笑声不打烊》新一期上线，多个段子在社交平台被广泛转发。",
    content: [
      "《笑声不打烊》最新一期上线后，多个段子迅速在社交平台传播开来，节目热度再度攀升。",
      "这一期节目中，演员们围绕日常生活展开创作，把琐碎的烦恼写成了会心一笑的段子。不少观众留言说，下班后看一期，一整天的疲惫都被治愈了。",
      "作为一档深夜喜剧综艺，节目始终坚持用幽默的方式回应生活，也因此收获了一批稳定观众。",
    ],
    inlineImage:
      "https://readdy.ai/api/search-image?query=Cozy%20night%20club%20stage%20with%20a%20spotlight%20and%20a%20microphone%20stand%2C%20warm%20ambient%20light%20and%20brick%20wall%2C%20editorial%20photography%2C%20warm%20orange%20and%20deep%20red%20tones%2C%20high%20detail&width=1200&height=675&seq=mgtv-n12-inline&orientation=landscape",
    cover:
      "https://readdy.ai/api/search-image?query=News%20photo%20of%20a%20warm%20comedy%20club%20stage%20with%20spotlight%20and%20sitting%20audience%2C%20warm%20orange%20and%20deep%20red%20tones%2C%20high%20detail&width=800&height=450&seq=mgtv-n12-cover&orientation=landscape",
    source: "芒果tv综艺",
    author: "综艺前线",
    publishedAt: "2025-09-18",
    tags: ["笑声不打烊", "脱口秀", "喜剧"],
  },
];